import { Box } from '@mui/material'
import { ExchengeFilters } from './ExchengeFilters'
import { P2pTable } from './P2pTable'

// import { P2pHeader } from './P2pHeader';

export const P2pIndexPage = () => {
    // const [searchParams] = useSearchParams();

    return (
        <>
            <Box pb={4}>
                {/* фильтры */}
                <ExchengeFilters />
                <P2pTable />
            </Box>
        </>
    )
}
